export default __webpack_public_path__ + "static/media/60.661ad43f.svg";